<template lang="pug">
  #wellness-leaderboard
    BDropdown.mb-4(
      v-model="organizationLeaderboard"
    )
      .sort-by-trigger(slot="trigger" slot-scope="{ active }")
        BButton(
          :label="organizationLeaderboard ? 'Organization Leaderboard' : 'Overall Leaderboard'"
          :icon-right="active ? 'chevron-up' : 'chevron-down'"
        )
      BDropdownItem(
        :value=0
      ) Overall Leaderboard
      BDropdownItem(
        :value=1
        v-if="displayOrganizationsOption"
      ) {{_.get(coreProgramMeta, "organizationsName", "Organization")}} Leaderboard
    WtLeaderboard(
      title=""
      :sub-title="leaderboardSubTitle"
      :data="{ data: getLeaderboardById(challengeId, 'data', organizationLeaderboard) }"
      isChallenge
      isPoints
      :loadedStatus="leaderboardLoaded"
      :maxX="challenge.totalPointsPossible"
      showPacer
      :pacerValue="pacerValue"
      :goalLine="challenge.totalPointsGoal"
      :showTooltipLabel="false"
    )
    WtPagination(
      :paginationObject="getLeaderboardById(challengeId, 'pagination')"
      @currentPage="currentLeaderboardPage = $event"
      order="is-centered"
    )

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtLeaderboard from "@@/WtLeaderboard/WtLeaderboard";
import WtPagination from "@@/WtPagination/WtPagination";

export default {
  name: "WellnessLeaderboard",

  components: {
    WtButton,
    WtTile,
    WtTitle,
    WtLeaderboard,
    WtPagination
  },

  props: {
    pacerValue: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      currentLeaderboardPage: 1,
      organizationLeaderboard: 0
    };
  },

  computed: {
    ...mapGetters("authMember", ["isAdmin"]),
    ...mapGetters("members", ["challenges"]),
    ...mapGetters("challenges", [
      "getLeaderboardById",
      "leaderboardLoaded",
      "getChallengeById"
    ]),
    ...mapGetters("program", ["coreProgramMeta", "isProTier"]),

    page() {
      return `Challenge${this.challengeId}`;
    },

    leaderboardSubTitle() {
      return "Total Points In Challenge";
    },

    challengeId() {
      return this.$route.params.challengeId;
    },

    challenge() {
      return this.getChallengeById(this.challengeId);
    },

    isCompleted() {
      const COMPLETED = 2;
      return (
        this.getChallengeById(this.$route.params.challengeId).status ===
        COMPLETED
      );
    },

    thisMembersPoints() {
      const leaderboard = this.getLeaderboardById(this.challengeId);

      const member = leaderboard.find(member => {
        return member.id === this.$auth.user().id;
      });
      return member ? member.points : null;
    },

    displayOrganizationsOption() {
      return (
        this.isProTier &&
        this._.get(this.coreProgramMeta, "organizationsOn", false)
      );
    }
  },

  watch: {
    async currentLeaderboardPage() {
      await this.fetchLeaderboard({
        challengeId: this.challenge.id,
        page: this.currentLeaderboardPage,
        perPage: 15
      });
    },
    async organizationLeaderboard() {
      await this.fetchLeaderboard({
        challengeId: this.challenge.id,
        page: this.currentLeaderboardPage,
        perPage: 15,
        organizationLeaderboard: this.organizationLeaderboard
      });
    }
  },

  methods: {
    ...mapActions("challenges", ["fetchLeaderboard"])
  }
};
</script>

<style lang="sass" scoped>
#wellness-leaderboard
</style>
